'use client';

import { RuntimeFailureBoundary } from '@/components/runtime-failure/runtime-failure-boundary';

export default function AppError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return <RuntimeFailureBoundary error={error} reset={reset} boundary="route" />;
}
